import { ProjectCustomerWhatsAppDTO } from '../../domain/project/ProjectDTO';
import { ProjectCustomerWhatsApp } from '../../domain/project/projectCustomerWhatsApp/ProjectCustomerWhatsApp';
import { ProjectCustomerWhatsAppItemMapper } from './ProjectCustomerWhatsAppItemMapper';

export class ProjectCustomerWhatsAppMapper {
  static toDomain(props: ProjectCustomerWhatsAppDTO): ProjectCustomerWhatsApp {
    const {
      stop_created,
      route_started,
      stop_approaching,
      stop_completed,
      stop_canceled,
      pickup_created,
      pickup_approaching,
      pickup_completed,
      pickup_canceled,
    } = props;

    return ProjectCustomerWhatsApp.create({
      stop_created: stop_created ? ProjectCustomerWhatsAppItemMapper.toDomain(stop_created) : undefined,
      route_started: route_started ? ProjectCustomerWhatsAppItemMapper.toDomain(route_started) : undefined,
      stop_approaching: stop_approaching ? ProjectCustomerWhatsAppItemMapper.toDomain(stop_approaching) : undefined,
      stop_completed: stop_completed ? ProjectCustomerWhatsAppItemMapper.toDomain(stop_completed) : undefined,
      stop_canceled: stop_canceled ? ProjectCustomerWhatsAppItemMapper.toDomain(stop_canceled) : undefined,
      pickup_created: pickup_created ? ProjectCustomerWhatsAppItemMapper.toDomain(pickup_created) : undefined,
      pickup_approaching: pickup_approaching
        ? ProjectCustomerWhatsAppItemMapper.toDomain(pickup_approaching)
        : undefined,
      pickup_completed: pickup_completed ? ProjectCustomerWhatsAppItemMapper.toDomain(pickup_completed) : undefined,
      pickup_canceled: pickup_canceled ? ProjectCustomerWhatsAppItemMapper.toDomain(pickup_canceled) : undefined,
    });
  }

  static toRepository(projectCustomerWhatsApp: ProjectCustomerWhatsApp): ProjectCustomerWhatsAppDTO {
    return {
      ...(projectCustomerWhatsApp?.stop_created
        ? {
            stop_created: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.stop_created),
          }
        : {}),
      ...(projectCustomerWhatsApp?.route_started
        ? {
            route_started: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.route_started),
          }
        : {}),
      ...(projectCustomerWhatsApp?.stop_approaching
        ? {
            stop_approaching: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.stop_approaching),
          }
        : {}),
      ...(projectCustomerWhatsApp?.stop_completed
        ? {
            stop_completed: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.stop_completed),
          }
        : {}),
      ...(projectCustomerWhatsApp?.stop_canceled
        ? {
            stop_canceled: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.stop_canceled),
          }
        : {}),
      ...(projectCustomerWhatsApp?.pickup_created
        ? {
            pickup_created: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.pickup_created),
          }
        : {}),
      ...(projectCustomerWhatsApp?.pickup_approaching
        ? {
            pickup_approaching: ProjectCustomerWhatsAppItemMapper.toRepository(
              projectCustomerWhatsApp?.pickup_approaching
            ),
          }
        : {}),
      ...(projectCustomerWhatsApp?.pickup_completed
        ? {
            pickup_completed: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.pickup_completed),
          }
        : {}),
      ...(projectCustomerWhatsApp?.pickup_canceled
        ? {
            pickup_canceled: ProjectCustomerWhatsAppItemMapper.toRepository(projectCustomerWhatsApp?.pickup_canceled),
          }
        : {}),
    };
  }
}
